module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gu-35820090ead0219b998c5ca00528e556.svg";